class CurrencyParser {
    public toLocaleString(value: number, minimumFractionDigits: number = 2, maximumFractionDigits: number = 2) {
        return value.toLocaleString('en', { minimumFractionDigits, maximumFractionDigits }).replace(/,/g,' ');
    }
}

export default new CurrencyParser();